// import external dependencies
import 'jquery';

// Import everything from autoload
import "./autoload/_bootstrap.js"

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

import 'isotope-layout/dist/isotope.pkgd.min'

/** Populate Router instance with DOM routes */
const routes = new Router({
    // All pages
    common,
    // Home page
    home,
    // About Us page, note the change from about-us to aboutUs.
    aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

$(function () {


    var $stores = $('.stores').isotope({
        // options
        itemSelector: '.store-element',
        layoutMode: 'fitRows',
        getSortData: {
            name: '[data-name]',
        },
        sortBy: ['name'],
    });

    $('.store-tabs').on('click', 'a', function () {
        var filterValue = $(this).attr('data-filter');
        $stores.isotope({filter: filterValue});
        $('.store-tabs').find('.active').removeClass('active');
        $(this).addClass('active');
    });

    $('.news-slider').owlCarousel({
        loop: false,
        margin: 30,
        nav: true,
        responsive: {
            0: {
                items: 1,
            },
            1150: {
                items: 2,
            },
        },
    });
});


// WEBPACK FOOTER //
// ./scripts/main.js